// Create types
export const INVOICETAXTYPE_CREATE_ERROR = 'INVOICETAXTYPE_CREATE_ERROR';
export const INVOICETAXTYPE_CREATE_LOADING = 'INVOICETAXTYPE_CREATE_LOADING';
export const INVOICETAXTYPE_CREATE_SUCCESS = 'INVOICETAXTYPE_CREATE_SUCCESS';
export const INVOICETAXTYPE_CREATE_VIOLATIONS = 'INVOICETAXTYPE_CREATE_VIOLATIONS';
export const INVOICETAXTYPE_CREATE_RESET = 'INVOICETAXTYPE_CREATE_RESET';

// Show types
export const INVOICETAXTYPE_SHOW_ERROR = 'INVOICETAXTYPE_SHOW_ERROR';
export const INVOICETAXTYPE_SHOW_LOADING = 'INVOICETAXTYPE_SHOW_LOADING';
export const INVOICETAXTYPE_SHOW_RETRIEVED_SUCCESS = 'INVOICETAXTYPE_SHOW_RETRIEVED_SUCCESS';
export const INVOICETAXTYPE_SHOW_RESET = 'INVOICETAXTYPE_SHOW_RESET';

// Update types
export const INVOICETAXTYPE_UPDATE_RESET = 'INVOICETAXTYPE_UPDATE_RESET';
export const INVOICETAXTYPE_UPDATE_UPDATE_ERROR = 'INVOICETAXTYPE_UPDATE_UPDATE_ERROR';
export const INVOICETAXTYPE_UPDATE_UPDATE_LOADING = 'INVOICETAXTYPE_UPDATE_UPDATE_LOADING';
export const INVOICETAXTYPE_UPDATE_UPDATE_SUCCESS = 'INVOICETAXTYPE_UPDATE_UPDATE_SUCCESS';
export const INVOICETAXTYPE_UPDATE_RETRIEVE_ERROR = 'INVOICETAXTYPE_UPDATE_RETRIEVE_ERROR';
export const INVOICETAXTYPE_UPDATE_RETRIEVE_LOADING = 'INVOICETAXTYPE_UPDATE_RETRIEVE_LOADING';
export const INVOICETAXTYPE_UPDATE_RETRIEVE_SUCCESS = 'INVOICETAXTYPE_UPDATE_RETRIEVE_SUCCESS';
export const INVOICETAXTYPE_UPDATE_UPDATE_VIOLATIONS = 'INVOICETAXTYPE_UPDATE_UPDATE_VIOLATIONS';

// List types
export const INVOICETAXTYPE_LIST_ERROR = 'INVOICETAXTYPE_LIST_ERROR';
export const INVOICETAXTYPE_LIST_LOADING = 'INVOICETAXTYPE_LIST_LOADING';
export const INVOICETAXTYPE_LIST_RESET = 'INVOICETAXTYPE_LIST_RESET';
export const INVOICETAXTYPE_LIST_VIEW = 'INVOICETAXTYPE_LIST_VIEW';
export const INVOICETAXTYPE_LIST_SUCCESS = 'INVOICETAXTYPE_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/invoicetaxtype/mutation-types.js